import { useMutation } from "react-query";
import { moveFleetToAnotherClient } from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

export function useMoveFleetToAnotherClient() {
  return useMutation(moveFleetToAnotherClient, {
    mutationKey: MUTATION_KEYS.moveFleetToAnotherClient,
    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
